import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MagnifyingGlass } from "react-loader-spinner";
import ScrollToTop from "../ScrollToTop";
import axios from "axios";

axios.defaults.baseURL = "https://api.freshcart4u.com";

const MyAccountAddress = () => {
  const navigate = useNavigate();
  const [loaderStatus, setLoaderStatus] = useState(true);
  const [addresses, setAddresses] = useState([]);

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    zip: "",
    phone: "",
    isDefault: false,
  });

  /* ======================
     AUTH + LOAD ADDRESSES
  ====================== */
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }
const handleLogout = () => {
  localStorage.clear();

  // hard redirect = 100% works
  window.location.href = "/MyAccountSignIn";
};
    const fetchAddresses = async () => {
      try {
        const res = await axios.get("/api/checkout/address", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setAddresses(res.data.addresses || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoaderStatus(false);
      }
    };

    fetchAddresses();
  }, [navigate]);

  /* ======================
     HANDLE CHANGE
  ====================== */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };
const handleLogout = () => {
  localStorage.clear();
  navigate("/MyAccountSignIn", { replace: true });
};

  /* ======================
     SAVE ADDRESS
  ====================== */
  const handleSaveAddress = async () => {
    try {
      const token = localStorage.getItem("token");

      await axios.post(
        "/api/checkout/address/save",
        { address: form },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setForm({
        firstName: "",
        lastName: "",
        address: "",
        city: "",
        zip: "",
        phone: "",
        isDefault: false,
      });

      window.location.reload(); // simple & safe refresh

    } catch (err) {
      console.error(err);
      alert("Failed to save address");
    }
  };

  return (
    <div>
      <ScrollToTop />

      <section className="py-4">
        <div className="container">
          <div className="row">

            {/* SIDEBAR */}
            <div className="col-lg-3 d-none d-md-block border-end">
              <ul className="nav flex-column nav-pills p-4 gap-2">
                <li><Link className="nav-link" to="/MyAccountOrder">Your Orders</Link></li>
                <li><Link className="nav-link active" to="/MyAccountAddress">Address</Link></li>
                <li><Link className="nav-link" to="/MyAccountSetting">Settings</Link></li>
                <li><Link className="nav-link" to="/MyAccountNotification">Notifications</Link></li>
                <li>
<button
  type="button"
  className="dropdown-item text-danger"
  onClick={() => {
    const ok = window.confirm("Are you sure you want to logout?");
    if (!ok) return;

    // 🔔 SHOW TOAST
    const toastEl = document.getElementById("logoutToast");
    if (toastEl && window.bootstrap) {
      const toast = new window.bootstrap.Toast(toastEl, {
        delay: 1500,
      });
      toast.show();
    }

    // ⏳ thoda delay so toast dikh jaaye
    setTimeout(() => {
      localStorage.clear();
      window.location.href = "/MyAccountSignIn";
    }, 1200);
  }}
>
  Logout
</button>

 
   
                </li> 
              </ul>
            </div>

            {/* CONTENT */}
            <div className="col-lg-9">
              {loaderStatus ? (
                <div className="text-center my-5">
                  <MagnifyingGlass height="80" width="80" color="#0aad0a" />
                </div>
              ) : (
                <div className="p-4">
                  <div className="d-flex justify-content-between mb-4">
                    <h3>Your Addresses</h3>
                    <button
                      className="btn btn-outline-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#addAddressModal"
                    >
                      Add Address
                    </button>
                  </div>

                  {addresses.length === 0 ? (
                    <p className="text-muted">No addresses saved.</p>
                  ) : (
                    addresses.map((a) => (
                      <div key={a._id} className="card p-3 mb-3">
                        <strong>{a.firstName} {a.lastName}</strong>
                        <p className="mb-0">{a.address}, {a.city} - {a.zip}</p>
                        <small>Phone: {a.phone}</small>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ADD ADDRESS MODAL */}
      <div className="modal fade" id="addAddressModal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content p-4">
            <h5 className="mb-3">Add New Address</h5>

            <input className="form-control mb-2" name="firstName" placeholder="First Name" onChange={handleChange} />
            <input className="form-control mb-2" name="lastName" placeholder="Last Name" onChange={handleChange} />
            <input className="form-control mb-2" name="address" placeholder="Address" onChange={handleChange} />
            <input className="form-control mb-2" name="city" placeholder="City" onChange={handleChange} />
            <input className="form-control mb-2" name="zip" placeholder="ZIP Code" onChange={handleChange} />
            <input className="form-control mb-3" name="phone" placeholder="Phone" onChange={handleChange} />

            <div className="form-check mb-3">
              <input className="form-check-input" type="checkbox" name="isDefault" onChange={handleChange} />
              <label className="form-check-label">Set as default</label>
            </div>

            <div className="text-end">
              <button className="btn btn-secondary me-2" data-bs-dismiss="modal">
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleSaveAddress}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyAccountAddress;
